import { Box, styled } from "@mui/material";

export const Container = styled(Box)`
  width: 100%;
  height: 380px;
  flex: 3;
`

